import { ContactStatus, ContactsOrderBy } from '@dev/ee-api/ee-api-models';
import { DEFAULT_ACTIVE_PAGE, DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { addParamToUrl, parseUrlParams } from '@/services/tools/handleUrlParams';

import { flatten } from 'lodash-es';
import { replace } from 'redux-first-history';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';

interface UrlParams {
    search?: string;
    statuses?: ContactStatus[] | ContactStatus;
    orderBy?: ContactsOrderBy;
    page?: number;
    perPage?: number;
}

export type ContactQueryParamsT = keyof UrlParams;

export const useContactQueryParams = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { listname, segmentname } = useParams<{ listname: string; segmentname: string }>();
    const {
        search: querySearch = '',
        statuses: queryStatuses,
        orderBy: queryOrderBy,
        page: queryPage = DEFAULT_ACTIVE_PAGE,
        perPage: queryPerPage = DEFAULT_PER_PAGE_COUNT,
    } = parseUrlParams<UrlParams>(location.search, { parseNumbers: true });

    const pushParamToUrl = (param: Partial<Record<ContactQueryParamsT, any>>) => {
        const search = addParamToUrl(param);
        if (location.search === search) {
            return null;
        }
        dispatch(replace({ search }));
    };

    return {
        querySearch,
        queryStatuses: queryStatuses ? flatten([queryStatuses]) : null,
        queryOrderBy,
        pushParamToUrl,
        queryPage: queryPage || DEFAULT_ACTIVE_PAGE,
        queryPerPage,
        listname,
        segmentname,
    };
};
